export default {
  GET_FREE_DOMAIN: 'get-free-subdomain',
  BUY_DOMAIN: 'buy-domain',
  THIRD_PARTY_DOMAIN: 'third-party-domain',
};
